export enum ERegistryPermission {
    ALL = 'ALL',
    MINE = 'MINE',
    SHARED = 'SHARED',
}